module.exports = __webpack_public_path__ + "img/clock-pink.7d31bab4.svg";